//#region imports
import { Component, HostListener, OnInit } from '@angular/core';
import { Globals } from './../../../../services/globals';
import { startWith, map } from 'rxjs/operators';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SignatureService } from 'src/app/services/signature.service';
import { Observable } from 'rxjs';
import { Signature5Answers } from '../../model/signature.model';
import { SectionService } from 'src/app/services/section.service';
import { SaveService } from 'src/app/services/save.service';
//#endregion

@Component({
  selector: 'app-signature-question5',
  templateUrl: './signature-question5.component.html',
  styleUrls: ['./signature-question5.component.css']
})
export class SignatureQuestion5Component implements OnInit {
  //#region variables
  locationList: Observable<string[]>;
  apiLocation: any = [];
  lang: number; // = 4.031187;
  latt: number; // = 50.921833;
  officeList = [];
  selectedoffice;
  invalidLocation = false;
  markedLocation;
  ID_IMD;
  mapForm = new FormGroup({
    officeName: new FormControl(null, [Validators.required])
  });
  initial = true;
  //#endregion

  // locationSource:'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62205.24959048031!2d77.68637437154769!3d12.98284419048961!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae11770030001d%3A0xdb4456bed482197c!2sEY%20Office%20Garnet%20BTP!5e0!3m2!1sen!2sin!4v1583918356568!5m2!1sen!2sin' ;

  //#region methods
  constructor(
    private signatureService: SignatureService, private globals: Globals, private saveservice: SaveService,
    private sectionService: SectionService) { }

  ngOnInit() {
    this.sectionService.setCurrentPage('P5-5');
    this.globals.trackPageActivity += ';' + 'P5-5';
    const country = this.signatureService.getSaveAddress1().Taker_Address_Country;
    const answers = this.signatureService.getSignature5Answers();
    
    if(answers !== undefined && answers !== null && answers.Sales_Office !== null && answers.ID_IMD !== null){
      let postalCode;
      if (country === 'BELGIQUE' || country === 'BELGIE' || country === 'BELGIEN') {
        postalCode = this.signatureService.getPropertyPostalCode();
      } else {
        postalCode = this.globals.propertyPostCode; // this.saveservice.getContactDetails().PostalCode;
      }
      this.signatureService.getOfficesLocation(postalCode).subscribe((response) => {
        this.apiLocation = response.GetMainOfficeForCPListResponse.GetMainOfficeForCPListResult.uspGetMainOfficeForCPListResult;       
        this.apiLocation.forEach(obj => this.officeList.push(obj.Bureau));
        this.officeList = [...new Set(this.officeList)];
        // this.officeList.forEach(o => o.slice(0, 20));
        this.officeList = this.officeList.sort();
        this.locationList = this.officeName.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value))
        );
        this.mapForm.patchValue({
          officeName: answers.Sales_Office
        });
        let mainOffice;
        // const mainOffice = this.apiLocation.filter(f => f.Bureau === answers.Sales_Office)[0] ? this.apiLocation.filter(f => f.Bureau === answers.Sales_Office)[0] : this.apiLocation[0];
        if (this.apiLocation.filter(f => f.Mainoffice === '1')[0] !== null && this.apiLocation.filter(f => f.Mainoffice === '1')[0] !== undefined)
          {
            if(answers.ID_IMD !== null && answers.ID_IMD !== undefined )
            {
              mainOffice = this.apiLocation.filter(f => f.ID_IMD === answers.ID_IMD)[0] ? this.apiLocation.filter(f => f.ID_IMD === answers.ID_IMD)[0] : this.apiLocation.filter(f => f.Mainoffice === '1')[0];
            } else{
              mainOffice = this.apiLocation.filter(f => f.Bureau === answers.Sales_Office)[0] ? this.apiLocation.filter(f => f.Bureau === answers.Sales_Office)[0] : this.apiLocation.filter(f => f.Mainoffice === '1')[0];
            }
          }
        else
        {
          if(answers.ID_IMD !== null && answers.ID_IMD !== undefined)
          {
            mainOffice = this.apiLocation.filter(f => f.ID_IMD === answers.ID_IMD)[0] ? this.apiLocation.filter(f => f.ID_IMD === answers.ID_IMD)[0] : this.apiLocation[0]; 
          }else{
            mainOffice = this.apiLocation.filter(f => f.Bureau === answers.Sales_Office)[0] ? this.apiLocation.filter(f => f.Bureau === answers.Sales_Office)[0] : this.apiLocation[0]; 
          }          
        }
        this.selectedoffice = mainOffice.Bureau;
        this.lang = Number(mainOffice.lgt);
        this.latt = Number(mainOffice.Lat);
        this.ID_IMD = mainOffice.ID_IMD;
        this.markedLocation = mainOffice.Bureau;
        this.globals.mapValues = this.apiLocation;
        this.initial = false;
        // this.apiLocation = this.globals.mapValues;        
        this.setSignature5AnswersAndSaveCriteria(this.markedLocation, this.latt, this.lang, this.ID_IMD);
      });
    }
    else {
      let postalCode;
      if (country === 'BELGIQUE' || country === 'BELGIE' || country === 'BELGIEN') {
        postalCode = this.signatureService.getPropertyPostalCode();
      } else {
        postalCode = this.globals.propertyPostCode; //this.saveservice.getContactDetails().PostalCode;
      }

      this.signatureService.getOfficesLocation(postalCode).subscribe((response) => {
        // console.log(response);
        this.apiLocation = response.GetMainOfficeForCPListResponse.GetMainOfficeForCPListResult.uspGetMainOfficeForCPListResult;
        this.apiLocation.forEach(obj => this.officeList.push(obj.Bureau));
        this.officeList = [...new Set(this.officeList)];
        this.locationList = this.officeName.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value))
        );
        this.mapForm.patchValue({
          officeName: this.officeList[0]
        });
        const mainOffice = this.apiLocation.filter(f => f.Mainoffice === '1')[0] ?
          this.apiLocation.filter(f => f.Mainoffice === '1')[0] : this.apiLocation[0];
        this.selectedoffice = mainOffice.Bureau;
        this.ID_IMD = mainOffice.ID_IMD;
        this.lang = Number(mainOffice.lgt);
        this.latt = Number(mainOffice.Lat);
        this.ID_IMD = mainOffice.ID_IMD;
        this.markedLocation = mainOffice.Bureau;
        this.globals.mapValues = this.apiLocation;
        this.initial = false;
        this.setSignature5AnswersAndSaveCriteria(this.markedLocation, this.latt, this.lang, this.ID_IMD);
      });
    }
    
  //   if (answers == null && answers.Sales_Office == null) {

  //   } else {
      
  //  }
  }

  @HostListener('window:beforeunload',['$event'])  //preventing on closing the page inbetween to show the dialog
  onWindowClose(event:any): void{
    //console.log('test');
    event.preventDefault();
    event.returnValue = false;
  }

  get officeName() {
    return this.mapForm.get('officeName');
  }

  private _filter(value: string): string[] {
    const filterValue = value != null ? value.toLowerCase() : value;
    return this.officeList.filter(option => option.toLowerCase().indexOf(filterValue) !== -1).sort();
  }

  onLocationChange(location: any) {
    this.invalidLocation = false;
    this.signatureService.setShowSignatureNext(!this.invalidLocation);
    // console.log(location);
    this.locationList = this.officeName.valueChanges.pipe(
      map(value => this._filter(value))
    );
    this.lang = Number(this.apiLocation.filter(obj => obj.Bureau === location.option.value)[0].lgt);
    this.latt = Number(this.apiLocation.filter(obj => obj.Bureau === location.option.value)[0].Lat);
    this.markedLocation = location.option.value;
    this.ID_IMD = this.apiLocation.filter(obj => obj.Bureau === location.option.value)[0].ID_IMD;
    this.setSignature5AnswersAndSaveCriteria(this.markedLocation, this.latt, this.lang, this.ID_IMD);
  }

  setSignature5AnswersAndSaveCriteria(salesOffice, lattitude: number, longitude: number, id: string) {
    const signature5Answers: Signature5Answers = {
      Sales_Office: salesOffice, Lattidude: lattitude, Longitude: longitude, ID_IMD: id
    };
    this.signatureService.setSignature5Answers(signature5Answers);
    const saveCriteria = this.signatureService.getSaveCriteria();
    saveCriteria.Sales_office = salesOffice;
    saveCriteria.ID_IMD = id;
    this.signatureService.setnoIntermediate(id);
    saveCriteria.Lattidude = lattitude.toString();
    saveCriteria.Longitude = longitude.toString();
    this.signatureService.setSaveCriteria(saveCriteria);
  }

  validateInput(value) {
    const locationValue = value !== undefined ? this.officeList.find(obj => obj === value) : 1;
    if (locationValue == null) {
      this.mapForm.controls.officeName.setErrors({ incorrect: true });
      this.invalidLocation = true;
    }
    else{
      this.removeValidators(this.mapForm, ['officeName']);
      this.invalidLocation = false;
    }
    this.signatureService.setShowSignatureNext(!this.invalidLocation);
  }
  removeValidators(form: FormGroup, keys) {
    for (const index in keys) {
        form.get(keys[index]).clearValidators();
        form.get(keys[index]).updateValueAndValidity();
    }
}
  //#endregion
}



